import loginEs from './pages/Login/es.json'
import disciplinesPageEs from './pages/VirtualRoomPage/ContentPage/DisciplinesPage/es.json'
import announcementsEs from './pages/Announcements/es.json'
import dropzoneAreaEs from './components/DropzoneArea/es.json'
import seeMoreComponentEs from './components/SeeMoreComponent/es.json'
import modalBodyComponentEs from './components/ModalBodyComponent/es.json'
import lessonsPageEs from './pages/VirtualRoomPage/ContentPage/LessonsPage/es.json'
import forumPageEs from './pages/VirtualRoomPage/ForumPage/es.json'
import forumClassesPageEs from './pages/VirtualRoomPage/ForumPage/ForumClassesPage/es.json'
import listForumPageEs from './pages/VirtualRoomPage/ForumPage/ListForumPage/es.json'
import boxComponentEs from './components/BoxComponent/es.json'
import newTopicPageEs from './pages/VirtualRoomPage/ForumPage/NewTopicPage/es.json'
import inputComponentEs from './components/InputComponent/es.json'
import uploadComponentEs from './components/UploadComponent/es.json'
import editTopicPageEs from './pages/VirtualRoomPage/ForumPage/EditTopicPage/es.json'
import imageEs from './pages/VirtualRoomPage/ContentPage/LessonContentPage/media/Image/es.json'
import videoEs from './pages/VirtualRoomPage/ContentPage/LessonContentPage/media/Video/es.json'
import audioEs from './pages/VirtualRoomPage/ContentPage/LessonContentPage/media/Audio/es.json'
import attachmentEs from './pages/VirtualRoomPage/ContentPage/LessonContentPage/media/Attachment/es.json'
import feedForumPageEs from './pages/VirtualRoomPage/ForumPage/FeedForumPage/es.json'
import datesEs from './pages/VirtualRoomPage/ForumPage/components/EditTopicForum/components/Dates/es.json'
import classesEs from './pages/VirtualRoomPage/ForumPage/components/EditTopicForum/components/Classes/es.json'
import indexEditTopicForumEs from './pages/VirtualRoomPage/ForumPage/components/EditTopicForum/components/index/es.json'
import helpPageEs from './pages/VirtualRoomPage/HelpPage/es.json'
import liveClassPageEs from './pages/VirtualRoomPage/LiveClassPage/es.json'
import contentEs from './pages/VirtualRoomPage/ContentPage/LessonContentPage/Content/es.json'
import conquestPageEs from './pages/VirtualRoomPage/ConquestPage/es.json'
import finalEs from './pages/VirtualRoomPage/ContentPage/LessonContentPage/Final/es.json'
import inputAttachEs from './pages/VirtualRoomPage/ForumPage/components/InputAttach/es.json'
import inputTextEs from './pages/VirtualRoomPage/ForumPage/components/InputText/es.json'
import pendencyWarningEs from './pages/VirtualRoomPage/ForumPage/components/PendencyWarning/es.json'
import postPublishEs from './pages/VirtualRoomPage/ForumPage/components/PostPublish/es.json'
import pendenciesEs from './pages/VirtualRoomPage/ForumPage/ListForumPage/components/Pendencies/es.json'
import classesPageEs from './pages/VirtualRoomPage/ReportsPage/ClassesPage/es.json'
import activityEs from './pages/VirtualRoomPage/ContentPage/LessonContentPage/activities/Activity/es.json'
import multipleChoiceEs from './pages/VirtualRoomPage/ContentPage/LessonContentPage/activities/MultipleChoice/es.json'
import orderEs from './pages/VirtualRoomPage/ContentPage/LessonContentPage/activities/Order/es.json'
import menuDropupEs from './pages/VirtualRoomPage/ContentPage/LessonContentPage/MenuDropup/es.json'
import clueEs from './pages/VirtualRoomPage/ContentPage/LessonContentPage/media/Clue/es.json'
import confirmationEs from './pages/VirtualRoomPage/ContentPage/LessonContentPage/Confirmation/es.json'
import lessonsEs from './pages/VirtualRoomPage/ForumPage/components/EditTopicForum/components/Lessons/es.json'
import forumFeedEs from './pages/VirtualRoomPage/ForumPage/components/ForumFeed/es.json'
import classesPageRankingEs from './pages/VirtualRoomPage/RankingPage/ClassesPage/es.json'
import rankingListPageEs from './pages/VirtualRoomPage/RankingPage/RankingListPage/es.json'
import disciplinesPageRankingEs from './pages/VirtualRoomPage/RankingPage/DisciplinesPage/es.json'
import attendanceReportEs from './pages/VirtualRoomPage/LiveClassPage/AttendanceReport/es.json'
import classRoomPageEs from './pages/VirtualRoomPage/LiveClassPage/ClassRoomPage/es.json'
import joinLiveClassEs from './pages/VirtualRoomPage/LiveClassPage/JoinLiveClass/es.json'
import liveClassModalsEs from './pages/VirtualRoomPage/LiveClassPage/Modals/es.json'
import pastClassesLiveEs from './pages/VirtualRoomPage/LiveClassPage/PastClasses/es.json'
import correctionModalEs from './pages/VirtualRoomPage/TaskDeliveryPage/modals/CorrectionModal/es.json'
import deleteTaskDeliveryModalEs from './pages/VirtualRoomPage/TaskDeliveryPage/modals/DeleteTaskDeliveryModal/es.json'
import allWorksEs from './pages/VirtualRoomPage/TaskDeliveryPage/tabs/all-works/es.json'
import correctionsEs from './pages/VirtualRoomPage/TaskDeliveryPage/tabs/corrections/es.json'
import newTaskEs from './pages/VirtualRoomPage/TaskDeliveryPage/tabs/new-task/es.json'
import studentWorksEs from './pages/VirtualRoomPage/TaskDeliveryPage/tabs/student-works/es.json'
import taskDeliveryPageEs from './pages/VirtualRoomPage/TaskDeliveryPage/es.json'
import profileAreaComponentEs from './components/ProfileAreaComponent/es.json'
import editProfilePageEs from './pages/EditProfilePage/es.json'
import roadBarStoreEs from './stores/RoadBarStore/es.json'
import forumStoreEs from './stores/ForumStore/es.json'
import courseStoreEs from './stores/CourseStore/es.json'
import reportsStoreEs from './stores/ReportsStore/es.json'
import trailStoreEs from './stores/TrailStore/es.json'
import virtualRoomStoreEs from './stores/VirtualRoomStore/es.json'
import disciplineStoreEs from './stores/DisciplineStore/es.json'
import IconBellComponentEs from './components/IconBellComponent/es.json'
import IconChatComponentEs from './components/IconChatComponent/es.json'
import NotificationAreaComponentEs from './components/NotificationAreaComponent/es.json'
import ChatEs from './components/Chat/es.json'
import UtilEs from './Util/es.json'
import editLiveClassEs from './components/IES2/EditLiveClass/es.json'
import liveClassCardEs from './components/IES2/LiveClassCard/es.json'
import ies2InputEs from './components/IES2/Input/es.json'
import forumModelEs from './models/ForumModel/es.json'
import jitsiEs from './components/IES2/JitsiIES2/es.json'
import tfActivityEs from './pages/VirtualRoomPage/ContentPage/LessonContentPage/activities/TF/es.json'
import writtenEs from './pages/VirtualRoomPage/ContentPage/LessonContentPage/activities/Written/es.json'
import reportsProgressEs from './pages/VirtualRoomPage/ReportsPage/Progress/es.json'
import reportsPerformanceEs from './pages/VirtualRoomPage/ReportsPage/Performance/es.json'
import reportsStudentPageEs from './pages/VirtualRoomPage/ReportsPage/StudentPage/es.json'
import reportsProgressPerformancePageEs from './pages/VirtualRoomPage/ReportsPage/ProgressPerformancePage/es.json'
import reportsModalMessageComponentEs from './pages/VirtualRoomPage/ReportsPage/ModalMessageComponent/es.json'
import vimeoEs from './components/IES2/Vimeo/es.json'
import lessonContentPageEs from './pages/VirtualRoomPage/ContentPage/LessonContentPage/es.json'
import formErrorsEs from './forms/errors/es.json'

const es = {
  ...loginEs,
  ...disciplinesPageEs,
  ...announcementsEs,
  ...dropzoneAreaEs,
  ...seeMoreComponentEs,
  ...modalBodyComponentEs,
  ...lessonsPageEs,
  ...forumPageEs,
  ...forumClassesPageEs,
  ...listForumPageEs,
  ...boxComponentEs,
  ...newTopicPageEs,
  ...inputComponentEs,
  ...uploadComponentEs,
  ...editTopicPageEs,
  ...imageEs,
  ...videoEs,
  ...audioEs,
  ...attachmentEs,
  ...feedForumPageEs,
  ...datesEs,
  ...classesEs,
  ...indexEditTopicForumEs,
  ...helpPageEs,
  ...liveClassPageEs,
  ...contentEs,
  ...conquestPageEs,
  ...finalEs,
  ...inputAttachEs,
  ...inputTextEs,
  ...pendencyWarningEs,
  ...postPublishEs,
  ...pendenciesEs,
  ...classesPageEs,
  ...activityEs,
  ...multipleChoiceEs,
  ...orderEs,
  ...menuDropupEs,
  ...clueEs,
  ...confirmationEs,
  ...lessonsEs,
  ...forumFeedEs,
  ...classesPageRankingEs,
  ...disciplinesPageRankingEs,
  ...rankingListPageEs,
  ...classRoomPageEs,
  ...liveClassModalsEs,
  ...pastClassesLiveEs,
  ...attendanceReportEs,
  ...joinLiveClassEs,
  ...correctionModalEs,
  ...deleteTaskDeliveryModalEs,
  ...allWorksEs,
  ...correctionsEs,
  ...newTaskEs,
  ...studentWorksEs,
  ...taskDeliveryPageEs,
  ...profileAreaComponentEs,
  ...editProfilePageEs,
  ...roadBarStoreEs,
  ...forumStoreEs,
  ...courseStoreEs,
  ...reportsStoreEs,
  ...trailStoreEs,
  ...virtualRoomStoreEs,
  ...disciplineStoreEs,
  ...IconBellComponentEs,
  ...IconChatComponentEs,
  ...NotificationAreaComponentEs,
  ...ChatEs,
  ...UtilEs,
  ...editLiveClassEs,
  ...liveClassCardEs,
  ...ies2InputEs,
  ...forumModelEs,
  ...jitsiEs,
  ...writtenEs,
  ...tfActivityEs,
  ...reportsProgressEs,
  ...reportsPerformanceEs,
  ...reportsStudentPageEs,
  ...reportsProgressPerformancePageEs,
  ...reportsModalMessageComponentEs,
  ...vimeoEs,
  ...lessonContentPageEs,
  ...formErrorsEs
}

export default es
